import {createApp} from 'vue';
import BrandsList from '../vue/brands-list/BrandsList.vue';

document.querySelectorAll( '.whippet-brands-list' ).forEach( widget => {
	createApp( BrandsList, widget.dataset ).mount( widget );
} );
